import io from 'socket.io-client'
import * as GameSocket from '@js/game-socket'
import { HOST } from '@/config'
import WS_TP from '@js/config/socket'
import gameBus from '@js/game-bus'
import AudioCtrl from '@js/audio-ctrl'
import { getSoundEffectUrl, TP as AudioTP } from '@js/config/audio/common'
import Utils from '@js/utils'
import shortName from '@js/config/short-name'

const { unitShortName } = shortName

function playChatAudio () {
  AudioCtrl.play({ url: getSoundEffectUrl(AudioTP.CHAT) })
}

function wrapChatData (rootState, channel, targetNick, content) {
  const userInfo = Utils.clone(rootState.user.userInfo) || {}
  return Object.assign({
    userInfo: {
      id: userInfo.id,
      nick: userInfo.nick,
      avatar: userInfo.avatar,
      username: userInfo.username,
    }
  }, {
    channel: channel,
    targetNick: targetNick,
    content: content,
  })
}

function formatQuery (obj = {}) {
  let res = ''
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      res += `&${key}=${obj[key]}`
    }
  }
  return res
}

const types = {
  SET_CONNECT: 'SET_CONNECT',
  DISCONNECT: 'DISCONNECT',
  // 房间
  REFRESH_ROOM_LIST: 'REFRESH_ROOM_LIST',
  ADD_ROOM: 'ADD_ROOM',
  UPDATE_ROOM: 'UPDATE_ROOM',
  DELETE_ROOM: 'DELETE_ROOM',
  // 副本
  REFRESH_FUBEN_LIST: 'REFRESH_FUBEN_LIST',
  ADD_FUBEN: 'ADD_FUBEN',
  UPDATE_FUBEN: 'UPDATE_FUBEN',
  DELETE_FUBEN: 'DELETE_FUBEN',
  ENTER_FUBEN: 'ENTER_FUBEN',
  // 战斗
  SET_PLAYER_DATA: 'SET_PLAYER_DATA',
  UPDATE_COMBAT_DATA: 'UPDATE_COMBAT_DATA',
  UPDATE_SPELLS: 'UPDATE_SPELLS',
  ADD_BATTLE_LOG: 'ADD_BATTLE_LOG',
  RESET_COMBAT_DATA: 'RESET_COMBAT_DATA',
  SET_SELECTED_SPELL: 'SET_SELECTED_SPELL',
  SET_SELECTED_SPELL_TARGET: 'SET_SELECTED_SPELL_TARGET',
  SET_IS_PLAYING_ANIMATION: 'SET_IS_PLAYING_ANIMATION',
  // 场景
  REFRESH_ONLINE_PLAYERS: 'REFRESH_ONLINE_PLAYERS',
  SCENE_HERO_MOVE: 'SCENE_HERO_MOVE',
  SCENE_HERO_OFFLINE: 'SCENE_HERO_OFFLINE',
  // 聊天
  CHAT_HISTORY: 'CHAT_HISTORY',
  ADD_CHAT_MESSAGE: 'ADD_CHAT_MESSAGE',
  UPDATE_CHAT_TARGET_LIST: 'UPDATE_CHAT_TARGET_LIST',
  SET_CHAT_TARGET: 'SET_CHAT_TARGET',
  APPEND_SYSTEM_MESSAGE: 'APPEND_SYSTEM_MESSAGE',

  COMBAT_HISTORY: 'COMBAT_HISTORY',
  ADD_COMBAT_HISTORY: 'ADD_COMBAT_HISTORY',
}

const getDefaultState = () => {
  return {
    connected: false,
    // 房间
    roomList: [],
    // 副本
    fubenList: [],
    // 场景
    onlinePlayers: [],

    // 战斗
    playerData: null,
    combatData: null,
    spells: [],
    selectedSpell: null,
    selectedSpellTarget: null,
    battleLog: [],
    isPlayingAnimation: false,

    // chat
    systemChatList: [],
    chatHistory: [],
    defaultChatTarget: [
      {
        channel: 0x02,
        placeholder: '世界频道',
      },
    ],
    chatTargetList: [],
    chatTarget: {
      channel: 0x02,
      nick: '',
    },
    // combatHistory
    combatHistory: [],
  }
}

const state = getDefaultState()

const getters = {
  connected (state) {
    return state.connected
  },

  roomList (state) {
    return state.roomList
  },

  player(state, getters, rootState) {
    const userInfo = rootState.user.userInfo
    return state.onlinePlayers.find((p) => p.uid === userInfo.id)
  },

  sceneId(state, getters) {
    return getters.player?.sceneId
  },

  onlinePlayers(state, getters) {
    return state.onlinePlayers.filter((p) => {
      return getters.player?.sceneId === p.sceneId
    })
  },

  chatHistory (state) {
    return state.chatHistory
  },

  chatTarget (state) {
    return state.chatTarget
  },

  chatTargetList (state) {
    return [...state.chatTargetList, ...state.defaultChatTarget]
  },

  combatHistory (state) {
    return state.combatHistory
  },

  // 房间信息
  roomInfo (state, getters, rootState) {
    const userInfo = rootState.user.userInfo
    // 当前玩家所在房间
    return state.roomList.find((room) => {
      return room.players.some((p) => {
        return p?.userId === userInfo.id
      }) || room.spectators.some((p) => {
        return p?.userId === userInfo.id
      })
    })
  },

  spectators (state, getters) {
    return getters.roomInfo?.spectators || []
  },

  isSpectator (state, getters, rootState) {
    const userInfo = rootState.user.userInfo || {}
    return getters.spectators.find((p) => {
      return p.userId === userInfo.id
    })
  },

  isOwner (state, getters, rootState) {
    const userInfo = rootState.user.userInfo || {}
    return getters.players[0]?.userId === userInfo?.id
  },

  playerData (state) {
    return state.playerData
  },
  // combatData (state) {
  //   return state.combatData || {}
  // },
  // teams (state) {
  //   return state.combatData?.teams || []
  // },
  spells (state) {
    return state.spells
  },
  // playerId (state) {
  //   return state.combatData?.playerId
  // },
  // players (state) {
  //   return state.combatData?.teams?.map((t) => {
  //     return t.players
  //   }).flat()
  // },
  // playerInfo (state, getters, rootState) {
  //   const userInfo = rootState.user.userInfo
  //   return getters.players.find((p) => p.userId === userInfo.id) || {}
  // },
  // isPlayer (state, getters, rootState) {
  //   const userInfo = rootState.user.userInfo
  //   return getters.players.some((p) => {
  //     return p.userId === userInfo.id
  //   })
  // },
  // cast (state, getters) {
  //   return getters.playerInfo.cast
  // },
  // inActionStack (state) {
  //   return (state.combatData?.stacks || [])[0]
  // },

  // 副本信息
  fubenInfo (state, getters, rootState) {
    const userInfo = rootState.user.userInfo
    // 当前玩家所在房间
    return state.fubenList.find((fuben) => {
      return fuben.players?.some((p) => {
        return p?.userId === userInfo.id
      })
    })
  },
}

const actions = {
  // 连接游戏频道
  connectGameChannel ({ commit, state, rootState, rootGetters, getters }) {
    return new Promise(async (resolve, reject) => {
      try {
        // console.log('[connectGameChannel]', rootState, rootGetters)
        const userInfo = rootState.user.userInfo
        const isLogged = rootGetters['user/isLogged']

        if (!isLogged) {
          reject({ code: 401, message: '请登录' })
          return
        }

        if (state.connected) {
          resolve()
          return
        }

        const token = localStorage.getItem('token') || ''
        const query = `token=${token}` + formatQuery(userInfo)
        const socket = io.connect(`${HOST}/game`, { query })

        if (socket) {
          commit(types.SET_CONNECT)
          GameSocket.init(socket)

          socket
            .on('connect', () => {
              log.green('[game connected]')
            })
            .on('disconnect', () => {
              log.red('[game disconnect]')
              if (socket) {
                socket.disconnect()
                commit(types.DISCONNECT)
              }
            })
            .on('authenticated', () => {
              log.green('[game authenticated]')
            })
            .on(WS_TP.SERVER.REFRESH_ROOM_LIST, (data) => {
              log.gray('[game REFRESH_ROOM_LIST]', data)
              commit(types.REFRESH_ROOM_LIST, data)
            })
            .on(WS_TP.SERVER.ADD_ROOM, (data) => {
              log.gray('[game ADD_ROOM]', data)
              commit(types.ADD_ROOM, data)
            })
            .on(WS_TP.SERVER.UPDATE_ROOM, (data) => {
              log.gray('[game UPDATE_ROOM]', data)
              commit(types.UPDATE_ROOM, data)
            })
            .on(WS_TP.SERVER.DELETE_ROOM, (data) => {
              log.gray('[game DELETE_ROOM]', data)
              commit(types.DELETE_ROOM, data)
            })
            // 副本
            .on(WS_TP.SERVER.ADD_FUBEN, (data) => {
              log.gray('[game ADD_FUBEN]', data)
              commit(types.ADD_FUBEN, data)
            })
            .on(WS_TP.SERVER.UPDATE_FUBEN, (data) => {
              log.gray('[game UPDATE_FUBEN]', data)
              commit(types.UPDATE_FUBEN, data)
            })
            .on(WS_TP.SERVER.DELETE_FUBEN, (data) => {
              log.gray('[game DELETE_FUBEN]', data)
              commit(types.DELETE_FUBEN, data)
            })
            .on(WS_TP.SERVER.ENTER_FUBEN, (data) => {
              log.gray('[game ENTER_FUBEN]', data)
              commit(types.ENTER_FUBEN, data)
            })
            // 聊天记录
            .on(WS_TP.CHAT.CHAT_HISTORY, (data) => {
              // console.log('[game CHAT.CHAT_HISTORY]', data)
              commit(types.CHAT_HISTORY, data)
            })
            // 战斗记录
            .on(WS_TP.CHAT.COMBAT_HISTORY, (data) => {
              // console.log('[game CHAT.COMBAT_LOGS]', data)
              commit(types.COMBAT_HISTORY, data)
            })
            // 战斗记录
            .on(WS_TP.CHAT.ADD_COMBAT_HISTORY, (data) => {
              log.gray('[game CHAT.ADD_COMBAT_HISTORY]', data)
              commit(types.ADD_COMBAT_HISTORY, data)
            })
            // 新聊天消息
            .on(WS_TP.CHAT.MESSAGE, (data) => {
              log.gray('[game CHAT.MESSAGE]', data)
              commit(types.ADD_CHAT_MESSAGE, data)
              if (data.channel !== 0x01) {
                playChatAudio()
              }
            })
            // 刷新在线玩家
            .on(WS_TP.SERVER.REFRESH_ONLINE_PLAYERS, (data) => {
              log.gray('[game REFRESH_ONLINE_PLAYERS]', data)
              const player = data.find((item) => item.uid === userInfo?.id)
              const scenePlayers = data.filter((p) => p.sceneId === player.sceneId)
              log.gray('[game SCENE PLAYERS]', scenePlayers)
              commit(types.REFRESH_ONLINE_PLAYERS, scenePlayers)
              gameBus.emit(WS_TP.SERVER.REFRESH_ONLINE_PLAYERS, scenePlayers)
            })
            // 场景英雄移动
            .on(WS_TP.SERVER.SCENE_HERO_MOVE, (data) => {
              log.gray('[game SCENE_HERO_MOVE]', data.sceneId, getters.sceneId, data)
              if (data.sceneId !== getters.sceneId) {
                return
              }
              commit(types.SCENE_HERO_MOVE, data)
              gameBus.emit(WS_TP.SERVER.SCENE_HERO_MOVE, data)
            })
            // 场景英雄离线
            .on(WS_TP.SERVER.SCENE_HERO_OFFLINE, (data) => {
              log.gray('[game SCENE_HERO_OFFLINE]', data)
              commit(types.SCENE_HERO_OFFLINE, data)
              gameBus.emit(WS_TP.SERVER.SCENE_HERO_OFFLINE, data)
            })

          resolve(socket)
          return
        }
        reject({ message: '未知错误，连接失败' })
      } catch (err) {
        console.error(err)
        reject(err)
      }
    })
  },

  // 断开连接
  disconnect ({ commit }) {
    const socket = GameSocket.socket
    if (socket) {
      socket.disconnect()
      GameSocket.disconnect()
      commit(types.DISCONNECT)
    }
  },

  // 发送聊天消息
  sendChatMessage ({ commit, rootState }, { targetNick = '', channel = 0x02, content = '' }) {
    GameSocket.socket.emit(
      WS_TP.CHAT.SEND_MESSAGE, wrapChatData(rootState, channel, targetNick, content.trim()))
  },

  appendSystemMessage ({ commit }, message) {
    commit(types.APPEND_SYSTEM_MESSAGE, message)
  },

  updateChatTargetList ({ commit, state }, { nick, onlyInsert = false }) {
    commit(types.UPDATE_CHAT_TARGET_LIST, { nick, onlyInsert })
  },

  setChatTarget ({ commit }, data) {
    commit(types.SET_CHAT_TARGET, data)
  },

  // 创建副本
  createFuben ({ commit }, data) {
    GameSocket.socket.emit(WS_TP.CLIENT.CREATE_FUBEN, data)
  },

  exitFuben ({ commit }, data) {
    GameSocket.socket.emit(WS_TP.CLIENT.EXIT_FUBEN, data)
  },

  // 创建房间
  createRoom ({ commit }, data) {
    GameSocket.socket.emit(WS_TP.CLIENT.CREATE_ROOM, data)
  },

  // 加入房间
  joinRoom ({ commit }, { roomId, password }) {
    GameSocket.socket.emit(WS_TP.CLIENT.JOIN_ROOM, { roomId, password })
  },

  // 加入观战
  joinWatch ({ commit }, { roomId, password }) {
    GameSocket.socket.emit(WS_TP.CLIENT.JOIN_WATCH, { roomId, password })
  },

  exitWatch () {
    GameSocket.socket.emit(WS_TP.CLIENT.EXIT_WATCH)
  },

  // 准备
  prepare ({}, data) {
    GameSocket.socket.emit(WS_TP.CLIENT.PREPARE, data)
  },

  // 添加 AI 玩家
  addAIPlayer ({}, { AIDifficulty = 1, AIVersion = 1, teamId, index = 0 }) {
    GameSocket.socket.emit(WS_TP.CLIENT.ADD_AI_PLAYER, { AIDifficulty, AIVersion, teamId, index })
  },

  // 更新配置
  updateAIFreeModeConfig ({}, data) {
    GameSocket.socket.emit(WS_TP.CLIENT.UPDATE_FREE_MODE_CONFIG, data)
  },

  // 进入战斗界面
  battlePageEntered () {
    GameSocket.socket.emit(WS_TP.CLIENT.ENTER_BATTLE_PAGE)
  },

  // 开始战斗
  startBattle () {
    GameSocket.socket.emit(WS_TP.CLIENT.START_BATTLE)
  },

  // 进入观战界面
  battleWatchEntered () {
    GameSocket.socket.emit(WS_TP.CLIENT.START_WATCH)
  },

  // 离开房间
  exitRoom ({}, data) {
    GameSocket.socket.emit(WS_TP.CLIENT.EXIT_ROOM, data)
  },

  // 移除 AI
  removeAIPlayer ({}, data) {
    GameSocket.socket.emit(WS_TP.CLIENT.REMOVE_AI_PLAYER, data)
  },

  changeTeam ({}, data) {
    GameSocket.socket.emit(WS_TP.CLIENT.CHANGE_TEAM, data)
  },

  // 玩家页面失去焦点
  sendPageBlur ({ commit }, isPageBlur) {
    GameSocket.socket.emit(WS_TP.CLIENT.PAGE_BLUR, +isPageBlur)
  },

  // 设置玩家数据
  setPlayerData ({ commit }, playerData) {
    commit(types.SET_PLAYER_DATA, playerData)
  },

  // 更新战斗数据
  updateCombatData ({ commit, state }, combatData) {
    if (!state.combatData || state.combatData.round < combatData.round) {
      commit(types.ADD_BATTLE_LOG, `回合 ${(combatData?.round || 0) + 1}`)
    }

    const d = JSON.parse(JSON.stringify(combatData))

    if (d.stacks) {
      d.stacks = d.stacks.map((stack) => {
        const result = {}
        for (let key in stack) {
          if (stack.hasOwnProperty(key)) {
            result[unitShortName[key] || key] = stack[key]
          }
        }
        return result
      })
    }
    if (d.deadStacks) {
      d.deadStacks = d.deadStacks.map((stack) => {
        const result = {}
        for (let key in stack) {
          if (stack.hasOwnProperty(key)) {
            result[unitShortName[key] || key] = stack[key]
          }
        }
        return result
      })
    }

    const updateData = Object.assign({}, state.combatData, d)
    commit(types.UPDATE_COMBAT_DATA, updateData)
  },

  // // 更新魔法
  // updateSpells ({ commit }, spells = []) {
  //   commit(types.UPDATE_SPELLS, spells)
  // },

  // 添加战斗日志
  addBattleLog ({ commit }, data) {
    commit(types.ADD_BATTLE_LOG, data)
  },

  // 重置战斗数据
  resetCombatData ({ commit }) {
    commit(types.RESET_COMBAT_DATA)
  },


  // 副本
  // 准备
  prepareFuben ({}, data) {
    GameSocket.socket.emit(WS_TP.CLIENT.PREPARE_FUBEN, data)
  },
}

const mutations = {
  [types.SET_CONNECT] (state) {
    state.connected = true
  },

  [types.DISCONNECT] (state) {
    state.connected = false
    Object.assign(state, getDefaultState())
  },

  // 玩家
  [types.REFRESH_ONLINE_PLAYERS] (state, onlinePlayers) {
    state.onlinePlayers = onlinePlayers
  },
  // 玩家移动
  [types.SCENE_HERO_MOVE] (state, data = {}) {
    const player = state.onlinePlayers.find((p) => p.uid === data.uid)
    if (player) {
      console.log('[update player coords]', data.to)
      player.sceneCoords = `${data.to?.row},${data.to?.col}`
    }
  },
  // 玩家离线
  [types.SCENE_HERO_OFFLINE] (state, data = {}) {
    const index = state.onlinePlayers.findIndex((p) => p.uid === data.uid)
    if (index !== -1) {
      state.onlinePlayers.splice(index, 1)
    }
  },

  // 房间
  [types.REFRESH_ROOM_LIST] (state, roomList) {
    console.log('>>> mutations [REFRESH_ROOM_LIST]', roomList)
    state.roomList = roomList
  },
  [types.ADD_ROOM] (state, room) {
    state.roomList.push(room)
  },
  [types.UPDATE_ROOM] (state, room) {
    for (let i = 0; i < state.roomList.length; i++) {
      const currRoom = state.roomList[i]
      if (currRoom.id === room.id) {
        state.roomList.splice(i, 1, room)
        break
      }
    }
  },
  [types.DELETE_ROOM] (state, roomId) {
    for (let i = 0; i < state.roomList.length; i++) {
      const currRoom = state.roomList[i]
      if (currRoom.id === roomId) {
        state.roomList.splice(i, 1)
        break
      }
    }
  },

  // 副本
  [types.REFRESH_FUBEN_LIST] (state, fubenList) {
    state.fubenList = fubenList
  },
  [types.ADD_FUBEN] (state, fuben) {
    state.fubenList.push(fuben)
  },
  [types.UPDATE_FUBEN] (state, fuben) {
    for (let i = 0; i < state.fubenList.length; i++) {
      const currFuben = state.fubenList[i]
      if (currFuben.id === fuben.id) {
        state.fubenList.splice(i, 1, fuben)
        break
      }
    }
  },
  [types.DELETE_FUBEN] (state, fubenId) {
    for (let i = 0; i < state.fubenList.length; i++) {
      const currFuben = state.fubenList[i]
      if (currFuben.id === fubenId) {
        state.fubenList.splice(i, 1)
        break
      }
    }
  },
  [types.ENTER_FUBEN] (state, ) {

  },

  // 聊天
  [types.CHAT_HISTORY] (state, chatHistory) {
    state.chatHistory = chatHistory.filter((item) => item.id !== 'sys_msg_slogan')
    state.systemChatList = chatHistory.filter((item) => item.id === 'sys_msg_slogan')
  },
  // 聊天
  [types.ADD_CHAT_MESSAGE] (state, message) {
    state.chatHistory.push(message)
  },
  [types.APPEND_SYSTEM_MESSAGE] (state, message) {
    const timestamp = Date.now()
    state.chatHistory.push({
      id: `sys_msg_local_${timestamp}`,
      channel: 0x01,
      speakerId: 'system',
      speaker: '系统消息',
      type: 'text',
      content: message,
      status: 'info',
      timestamp: timestamp,
    })
  },
  [types.SET_CHAT_TARGET] (state, data) {
    state.chatTarget.channel = data.channel
    state.chatTarget.nick = data.nick
  },

  [types.UPDATE_CHAT_TARGET_LIST] (state, { nick, onlyInsert = false }) {
    if (!nick) {
      return
    }

    const index = state.chatTargetList.findIndex(item => item.nick === nick)
    if (onlyInsert && index !== -1) {
      return
    }

    let item
    if (index !== -1) {
      item = state.chatTargetList.splice(index, 1)[0]
      state.chatTargetList.push(item)
    } else {
      item = {
        channel: 0x03,
        nick: nick,
      }
      state.chatTargetList.push(item)
    }
    state.chatTarget.channel = item.channel
    state.chatTarget.nick = item.nick
  },

  // 战斗记录
  [types.COMBAT_HISTORY] (state, combatHistory) {
    state.combatHistory = combatHistory
  },
  // 战斗记录
  [types.ADD_COMBAT_HISTORY] (state, combatHistory) {
    state.combatHistory.push(combatHistory)
  },

  // 战斗
  [types.SET_PLAYER_DATA] (state, playerData) {
    state.playerData = playerData
  },

  [types.UPDATE_COMBAT_DATA] (state, combatData) {
    state.combatData = combatData
  },

  // [types.UPDATE_SPELLS] (state, spells) {
  //   state.spells = spells
  // },

  [types.ADD_BATTLE_LOG] (state, log) {
    state.battleLog.push(...log.split(/[\r\n]g/))
  },

  [types.RESET_COMBAT_DATA] (state) {
    state.playerData = null
    state.combatData = null
    state.battleLog = []
  },

}

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
}
